import '../static/icons.css';
import '../static/fonts.css';
import '../static/global.css';

import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {}
});

export default app;